import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
const EventRegistrationDrawerContext = createContext(null);
export const EventRegistrationDrawerProvider = ({ children, embeddedPreview = false, previewLayout, hideNavLinks = false }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [contactUsOpen, setContactUsOpen] = useState(false);
    const [faqsOpen, setFaqsOpen] = useState(false);
    const [summaryOpen, setSummaryOpen] = useState(false);
    const [showSummaryPreviewButton, setShowSummaryPreviewButton] = useState(false);
    const [summarySteps, setSummarySteps] = useState([]);
    useEffect(() => {
        const drawer = searchParams.get('drawer');
        if (drawer === 'faq') {
            setFaqsOpen(true);
            setContactUsOpen(false);
        }
        else if (drawer === 'contact') {
            setContactUsOpen(true);
            setFaqsOpen(false);
        }
        if (drawer) {
            const next = new URLSearchParams(searchParams);
            next.delete('drawer');
            setSearchParams(next, { replace: true });
        }
    }, [searchParams, setSearchParams]);
    const openMobileMenu = useCallback(() => setIsMobileMenuOpen(true), []);
    const closeMobileMenu = useCallback(() => setIsMobileMenuOpen(false), []);
    const openContactUs = useCallback(() => {
        setIsMobileMenuOpen(false);
        setFaqsOpen(false);
        setSummaryOpen(false);
        setContactUsOpen(true);
    }, []);
    const closeContactUs = useCallback(() => setContactUsOpen(false), []);
    const openFaqs = useCallback(() => {
        setIsMobileMenuOpen(false);
        setContactUsOpen(false);
        setSummaryOpen(false);
        setFaqsOpen(true);
    }, []);
    const closeFaqs = useCallback(() => setFaqsOpen(false), []);
    const openSummary = useCallback(() => {
        setIsMobileMenuOpen(false);
        setContactUsOpen(false);
        setFaqsOpen(false);
        setSummaryOpen(true);
    }, []);
    const closeSummary = useCallback(() => setSummaryOpen(false), []);
    const value = useMemo(() => ({
        embeddedPreview,
        previewLayout,
        hideNavLinks,
        isMobileMenuOpen,
        contactUsOpen,
        faqsOpen,
        summaryOpen,
        showSummaryPreviewButton,
        summarySteps,
        openMobileMenu,
        closeMobileMenu,
        openContactUs,
        closeContactUs,
        openFaqs,
        closeFaqs,
        openSummary,
        closeSummary,
        setShowSummaryPreviewButton,
        setSummarySteps
    }), [
        embeddedPreview,
        previewLayout,
        hideNavLinks,
        isMobileMenuOpen,
        contactUsOpen,
        faqsOpen,
        summaryOpen,
        showSummaryPreviewButton,
        summarySteps,
        openMobileMenu,
        closeMobileMenu,
        openContactUs,
        closeContactUs,
        openFaqs,
        closeFaqs,
        openSummary,
        closeSummary
    ]);
    return (_jsx(EventRegistrationDrawerContext.Provider, { value: value, children: children }));
};
export const useEventRegistrationDrawerContext = () => {
    const context = useContext(EventRegistrationDrawerContext);
    if (!context) {
        throw new Error('useEventRegistrationDrawerContext must be used within EventRegistrationDrawerProvider');
    }
    return context;
};
